//Constant file to export constant variable to components


//Stripe Payment key message

export const STRIPEKEY = 'pk_live_9EgeANWKb6qViRUBr8xEexM2';
export const STRIPE_HEADER_NAME = 'SurePointAgSystems';
export const CURRENCY = 'USD';
export const STRIPE_PAY_BUTTON = 'Pay for Marksman Subscription';
export const STRIPE_RENEW_BUTTON = 'Renew Subscription Plan';

/*
export const STRIPEKEY = 'pk_test_j78GMHTU83ROBatSxp0kSKHk00lMRgUq4h';
export const STRIPE_HEADER_NAME = 'SureFireAgSystems';
export const CURRENCY = 'USD';
export const STRIPE_PAY_BUTTON = 'Pay for Marksman Subscription';
export const STRIPE_RENEW_BUTTON = 'Renew Subscription Plan';
*/
//Error Message
export const SUCCESS = 'Success'
export const NO_DISCOUNT_LABEL = 'No discount label specified'
export const ENTER_DISCOUNT_LABEL = 'Please enter discount label name.'
export const NO_DISCOUNT = 'No discount specified'
export const ENTER_DISCOUNT_VAL = 'Please enter discount value.'
export const VALID_DISCOUNT_VAL = 'Please enter valid discount value.'
export const SUCCESS_DISCOUNT_LABEL_CREATE = 'Discount label successfully created.'
export const SUCCESS_DISCOUNT_LABEL_UPDATE = 'Discount label successfully updated.'
export const SUB_PLAN_CREATED = 'Subscription plan successfully created.'
export const NO_VALUE = 'No value specified'
export const NO_YEAR = 'No Year selected'
export const ENTER_SUBS_PLAN = 'Please enter subscription plan name.'
export const ENTER_SUBS_PLAN_PRICE = 'Please enter subscription plan price.'
export const VALID_SUBS_PLAN_PRICE = 'Please enter valid subscription plan price.'
export const ENTER_SUBS_PLAN_DAYS = 'Please enter initial free subscription Days.'
export const VALID_SUBS_PLAN_DAYS = 'Please enter valid initial free subscription Days.'
export const SELECT_PLAN_YEAR = 'Please select subscription plan Year.'
export const SUBS_PLAN_RENEWED = 'Your subscription plan has been successfully renewed.'
export const NO_TEAM_SELECT = 'No team selected'
export const NO_DISCOUNT_LABEL_SELECT = 'No discount label selected'
export const SELECT_TEAM = 'Please select a team.'
export const SELECT_DISC_LABEL = 'Please select a discount label.'
export const ASSIGN_DISCOUNT_SUCCESS = 'Discount successfully assigned to team.'
export const ASSIGN_DISCOUNT_UPDATE = 'Subscription discount successfully updated.'
export const SUBS_PLAN_RENEW_SUCCESS = 'Subscription plan has been successfully renewed.'
export const SUBS_PLAN_EXPIRE = 'Subscription plan has expired.'
export const FREE_SUBS_PLAN_EXPIRE_SUPPORT = 'Subscription trial plan has expired. Please assign a new subscription plan to this controller.'
export const FREE_SUBS_PLAN_EXPIRE_CUSTOMER = 'Subscription trial plan has expired. Please contact support.'
export const ASSIGN_PLAN_CONTROLLER = 'Assign plan to controller'
export const SUBS_PLAN_NOT_ASSIGN = 'Subscription plan not assigned.'
export const PAY_DATA_NOT_FOUND= 'Payment data not found.'
export const CONFIRM_HEADER = 'Confirm'
export const ACTIVATE_DISC_LABEL = 'Are you sure you want to activate this discount label ?'
export const DEACTIVATE_DISC_LABEL = 'Are you sure you want to deactivate this discount label ?'
export const NO_CONTROLLER_SELECT = 'No controller selected'
export const NO_EMAIL = 'No Email specified'
export const SELECT_CONTROLLER = 'Please select one or more controllers to assign.'
export const ENTER_USER_EMAIL = "Please enter a user's email address to assign controllers to."
export const ENTER_CONTROLLER_PHONE = 'Please enter controller Phone Number.'
export const ENTER_EXTEND_VAL = 'Please enter Extend Days value.'
export const ENTER_VALID_EXTEND_VAL = 'Please enter valid Extend Days value.'
export const EXTEND_VAL_UPDATE = 'Extended days successfully updated.'
export const EXPIRED_STATUS = 'Expired'
export const TRIAL_STATUS = 'Trial'
export const ACTIVE_STATUS = 'Active'
export const EXPIRING_STATUS = 'Expiring'
export const PAYMENT_SUCCESS = 'Your payment was successfully completed.'
export const NOT_FOUND = 'Not found'
export const PAY_HISTORY_NOT_FOUND= 'Payment history not found for this controller.'
export const ENTER_PAY_REF_NUMBER = 'Please enter payment refrence number.'
export const SELECT_SUBS_PLAN = 'Please select subscription plan.'
export const DEFAULT_SUBS_PLAN_UPDATE = 'Default subscription plan has been successfully updated.'
export const INITIAL_PLAN_UPDATE = 'Initial subscription free plan has been successfully updated.'
export const SUBS_PLAN_PRICE_UPDATE = 'Subscription plan & price has been successfully updated.'
export const FAIL_ASSIGN_CONTROLLER_TEAM = 'Failed to assign controller to team'
export const ISSUE_ASSIGN_CONTROLLER = 'There was an issue assigning the controller. Please verify the serial number and try again.'
export const TEAM_NOT_FOUND = 'Team not found'
export const NO_TEAM = 'No team selected'
export const DATA_NOT_FOUND = 'Data not found.'
export const SELECT_CHECKBOX = 'Please select a checkbox.'
export const NO_VALUE_SELECT = 'No value selected'
export const SELECT_OPTIONS = 'Please select an option to generate report.'
export const EXPIRED_CON_NOT_FOUND = 'Expired controllers not found.'
export const ABOUT_CON_NOT_FOUND = 'About expire controllers not found.'
export const ENTER_EXPIRING_DAYS = 'Please enter about expire days.'
export const VALID_EXPIRING_DAYS = 'Please enter valid about expire days.'
export const ABOUT_EXPIRE_DAYS_UPDATE = 'About expire days has been successfully updated.'
export const RENEWED_CON_NOT_FOUND = 'Renewed controllers not found.'
export const SELECT_START_DATE = 'Please select start date.'
export const SELECT_END_DATE = 'Please select end date.'
export const INVALID_QUOTE = 'Please enter valid Quote Number.'

export const SUBS_HELPER_CONSTLIST = {
    UNABLE_FIND_SUBSLIST : 'Unable to find subscription plan list.',
    UNABLE_FIND_SUBSDATA : 'Unable to find subscription plan data.',
    NOT_UPDATE : 'Not updated',
    UNABLE_UPDATE_FREEDAYS : 'Unable to update initial free plan days.',
    NOT_EXTEND : 'Not extended',
    UNABLE_EXTEND_FREEDAYS : 'Unable to extend subscription plan days.',
    NOT_CREATED : 'Not created',
    UNABLE_CREATE_SUBSPLAN : 'Unable to create subscription plan. Plan with this name already exists.',
    NOT_RENEWED : 'Not renewed',
    UNABLE_RENEW_SUBSPLAN : 'Unable to renew subscription plan.',
    PAYMENT_FAIL : 'Payment failed',
    NOT_SAVED : 'Not saved',
    UNABLE_SAVE_PAYMENt : 'Unable to save payment details.',
    UNABLE_FIND_SUBSPRICE :  'Unable to get subscription price.',
    UNABLE_FIND_INVOICE : 'Unable to get Invoice data.',
    UNABLE_FIND_SUBSPLAN : 'Unable to find subscription plan.',
    UNABLE_FIND_SUBSCONTROLLER : 'Unable to find subscription controllers.',
    UNABLE_FIND_PAYMENT : 'Unable to find payment data.',
    UNABLE_UPDATE_PLANPRICE : 'Unable to update subscription plan & price.',
    UNABLE_FIND_DEALERS : 'Unable to find dealers.',
    UNABLE_FIND_DEALER_TEAMLIST : 'Unable to find dealer teams.',
    UNABLE_FIND_DEFAULT_SUBSPLAN : 'Unable to find default subscription plan.',
    UNABLE_FIND_DISCOUNT_LIST : 'Unable to find discount list.',
    NOT_ASSIGNED : 'Not assigned',
    UNABLE_ASSIGN_DISCOUNT_TEAM : 'Unable to assign discount to team.',
    UNABLE_FIND_DISCOUNT_TEAM :  'Unable to find discount for team.',
    UNABLE_UPDATE_DISCOUNT_TEAM : 'Unable to update discount label for team.',
    UNABLE_CREATE_DISCOUNT_LABEL : 'Unable to created discount label.',
    UNABLE_UPDATE_DISCOUNT : 'Unable to update discount value.',
    UNABLE_CHANGE_DISCOUNT : 'Unable to change status of discount label.',
    UNABLE_UPDATE_DEFAULT_PLAN : 'Unable to update default subscription plan.',
    NOT_DOWNLOAD  : 'Not downloaded',
    UNABLE_DOWNLOAD_INVOICE : 'Unable to download the invoice.',
    UNABLE_CREATE_CUSTOMER : 'Unable to add ACH customer.',
    UNABLE_VERIFY_CUSTOMER : 'Unable to verify ACH customer.',
    INVALID_REQUEST : 'Invalid request error',
    ACCOUNT_NOT_VERIFY : "Customer's bank account is not verified.",
    STRIPE_NOT_LOAD : "Stripe.js hasn't loaded yet.",
    UNABLE_FIND_EXPIRED_CONTROLLER: 'Unable to find expired controllers.',
    UNABLE_FIND_ABOUT_EXPIRED: 'Unable to find data for expired controllers.',
    UNABLE_FIND_PAYMENT_REPORT: 'Unable to find payment data.',
    UNABLE_UPDATE_EXPIRING_DAYS: 'Unable to update expiration setting.',
    UNABLE_FIND_RENEWED_CONTROLLER: 'Unable to find renewed controllers.',
}



// WEBPACK FOOTER //
// ./src/constants/index.js